/**
 * 商品一覧 SP 表示フィルター用 teleport (移動) 処理
 *
 * 背景:
 *   form (position: fixed; inset: 0) が祖先の包含ブロック化により viewport ではなく
 *   画面端 (x: 136px) にずれて表示される問題。祖先要素全数走査でも CSS 仕様上の
 *   包含ブロック作成プロパティは検出されず、CSS では追えないため、JS で form を
 *   <body> 直下に物理的に移動する方式で祖先関係を断つ。
 *
 * 副作用対策:
 *   - facets.liquid の close ボタン / 適用ボタンの onclick (closest('details') /
 *     closest('.mobile-facets__wrapper')) を id 参照に書き換え
 *   - global.js MenuDrawer.onCloseButtonClick に null フォールバック追加
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = '(max-width: 749px)';
  var FORM_ID = 'FacetFiltersFormMobile';
  var DETAILS_ID = 'FacetMobileDetails';

  var form = null;
  var details = null;
  var originalParent = null;
  var originalNextSibling = null;
  var isTeleported = false;

  function teleport() {
    if (isTeleported || !form) return;
    originalParent = form.parentNode;
    originalNextSibling = form.nextSibling;
    document.body.appendChild(form);
    isTeleported = true;
  }

  function untele() {
    if (!isTeleported || !form || !originalParent) return;
    if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
      originalParent.insertBefore(form, originalNextSibling);
    } else {
      originalParent.appendChild(form);
    }
    isTeleported = false;
  }

  function syncOpenState() {
    if (!form || !details) return;
    if (details.open) {
      form.classList.add('menu-opening');
    } else {
      form.classList.remove('menu-opening');
    }
  }

  function handleViewportChange(mql) {
    if (mql.matches) {
      teleport();
      syncOpenState();
    } else {
      form && form.classList.remove('menu-opening');
      untele();
    }
  }

  function init() {
    form = document.getElementById(FORM_ID);
    details = document.getElementById(DETAILS_ID);
    if (!form || !details) return;

    var mql = window.matchMedia(MOBILE_BREAKPOINT);
    handleViewportChange(mql);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleViewportChange);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(handleViewportChange);
    }

    details.addEventListener('toggle', syncOpenState);

    // オーバーレイ (form 自身) or 閉じるボタンクリック時:
    //   - form の menu-opening を即時削除して、open と同じ transition で
    //     スムーズに閉じるアニメを開始 (Dawn の closeAnimation 400ms wait は
    //     details.open=false の遅延であって、アニメ自体は即時開始したい)
    //   - オーバーレイクリック時は summary.click() で details の閉じ処理を起動
    form.addEventListener('click', function (e) {
      var isCloseButton = e.target.closest('.c-mobile-facets__close, .mobile-facets__close');
      var isOverlay = e.target === form;
      if (!isCloseButton && !isOverlay) return;
      form.classList.remove('menu-opening');
      if (isOverlay && details.open) {
        var summary = details.querySelector('summary');
        if (summary) summary.click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * SP 表示時、絞り込みボタン (.c-facets-wrapper) の挙動:
 *   - 初期: 定位置 (商品グリッド上部) で普通に配置
 *   - スクロールで元の位置から離れたら fixed 化 (ヘッダー下中央) + ふわっと animation
 *   - スクロールバックで元位置以上に戻ったら static に戻す
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = '(max-width: 749px)';

  // 2026-08-16: No.71 の正体は絞り込みボタンではなく「カート追加後モーダルの残存」と
  // 判明した（門間さんのスクリーンショットで確定、cart-notification.js 側で修正）。
  // 08-10 に誤特定でこの追従を止めたが、本来の設計挙動のため元に戻す。
  var ENABLE_FLOATING = true;

  function init() {
    var wrapper = document.querySelector('.c-facets-wrapper');
    if (!wrapper) return;

    var originalTop = 0;
    var isFloating = false;
    var headerEl = document.querySelector('.section-header, .header-wrapper, header');
    // 商品一覧グリッドを「フェードアウト判定」の基準にする
    var listEl = document.getElementById('product-grid')
      || document.querySelector('.c-product-grid')
      || document.querySelector('.product-grid-container');

    // floating 化時に元位置のスペースを保持するための placeholder
    var placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';
    placeholder.style.pointerEvents = 'none';
    wrapper.parentNode.insertBefore(placeholder, wrapper);

    function getHeaderHeight() {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var n = parseInt(v, 10);
      if (!isNaN(n)) return n;
      return headerEl ? headerEl.getBoundingClientRect().height : 63;
    }

    function measureOriginal() {
      if (isFloating) return;
      var rect = wrapper.getBoundingClientRect();
      originalTop = rect.top + window.scrollY;
    }

    function isMobile() {
      return window.matchMedia(MOBILE_BREAKPOINT).matches;
    }

    function activateFloating() {
      var rect = wrapper.getBoundingClientRect();
      placeholder.style.width = rect.width + 'px';
      placeholder.style.height = rect.height + 'px';
      placeholder.style.display = 'block';
      wrapper.classList.add('is-floating');
      // 初期状態を inline 直接指定 + transition 切る (初期値を瞬時に確定するため)
      wrapper.style.transition = 'none';
      wrapper.style.opacity = '0';
      wrapper.style.transform = 'translateX(-50%) translateY(-12px)';
      isFloating = true;
      // 強制 reflow して初期状態をブラウザに認識させる
      void wrapper.offsetWidth;
      // 次フレームで transition 有効化 + 目標値設定 → ふわっと
      requestAnimationFrame(function () {
        if (!isFloating) return;
        wrapper.style.transition = 'opacity 700ms ease-out, transform 700ms ease-out';
        wrapper.style.opacity = '1';
        wrapper.style.transform = 'translateX(-50%) translateY(0)';
      });
    }

    function deactivateFloating() {
      wrapper.classList.remove('is-floating', 'is-fading-out');
      wrapper.style.transition = '';
      wrapper.style.opacity = '';
      wrapper.style.transform = '';
      placeholder.style.display = 'none';
      isFloating = false;
    }

    function fadeOutFloating() {
      if (!isFloating) return;
      wrapper.classList.add('is-fading-out');
      wrapper.style.transition = 'opacity 300ms ease';
      wrapper.style.opacity = '0';
    }

    function fadeInFloating() {
      if (!isFloating) return;
      wrapper.classList.remove('is-fading-out');
      wrapper.style.transition = 'opacity 300ms ease';
      wrapper.style.opacity = '1';
    }

    function isBeyondListBottom() {
      if (!listEl) return false;
      var rect = listEl.getBoundingClientRect();
      // 商品一覧の下端が「ボタン表示エリア」より上に来たらフェードアウト
      // (ヘッダー下 + ボタン高さ + 余白 ≒ 120px ライン)
      var fadeLine = getHeaderHeight() + 80;
      return rect.bottom < fadeLine;
    }

    function update() {
      if (!ENABLE_FLOATING || !isMobile()) {
        if (isFloating) deactivateFloating();
        return;
      }
      var threshold = originalTop - getHeaderHeight() - 16;
      if (window.scrollY > threshold + 8) {
        if (!isFloating) activateFloating();
        if (isBeyondListBottom()) {
          fadeOutFloating();
        } else {
          fadeInFloating();
        }
      } else if (window.scrollY < threshold - 8) {
        if (isFloating) {
          deactivateFloating();
          measureOriginal();
        }
      }
    }

    window.addEventListener('load', function () {
      measureOriginal();
      update();
    });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      if (isFloating) deactivateFloating();
      measureOriginal();
      update();
    });

    // 初回測定 (load 前に scroll 発生する場合に備える)
    measureOriginal();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
